export const getBrands = ({ t, storeUrl, evinAkli, vfit }) => {
  return [
    {
      logoSrc: require("../assets/images/vestelLogo1.png"),
      href: storeUrl,
      text: t("home.vestel"),
      vertical: true,
      ssoTarget: process.env.REACT_APP_STORE_URL,
      returnUrl: "/",
    },
    {
      logoSrc: require("../assets/images/Vestel_Akilli_Yasam_ikon_final.png"),
      href: evinAkli,
      text: t("home.evinAkli"),
    },
    {
      logoSrc: require("../assets/images/Vestel_Akilli_Saglik_ikon_final.png"),
      href: vfit,
      text: t("home.vfit"),
    },
    {
      logoSrc: require("../assets/images/vsOutlet1.png"),
      href: `${process.env.REACT_APP_VSOUTLET_STORE_URL}/customer/login`,
      text: t("home.vsoutlet"),
      vertical: true,
      ssoTarget: process.env.REACT_APP_VSOUTLET_STORE_URL,
      returnUrl: "/",
    },
    {
      logoSrc: require("../assets/images/regal1.png"),
      href: `${process.env.REACT_APP_REGAL_STORE_URL}/customer/login`,
      text: t("home.regal"),
      vertical: true,
      ssoTarget: process.env.REACT_APP_REGAL_STORE_URL,
      returnUrl: "/",
    },
    {
      logoSrc: require("../assets/images/vestelLogo1.png"),
      href: process.env.REACT_APP_SUPPORT_URL,
      text: t("home.supportCenter"),
      vertical: true,
    },
  ];
};
